import React, { useEffect, useRef, useState } from 'react';
import {
  ECardImage,
  EarlyLoadECardImage,
  ECardImageWrapper,
  ECardWrapper,
} from '@components/GalleryComponents/GalleryECard/GalleryECard.styles';
import { useTranslation } from 'react-i18next';

interface Props
  extends Readonly<{
    index: number;
    data: GalleryECard;
    isHovered: boolean;
    isSlider: boolean;
  }> {}

const DEFAULT_ASPECT_RATIO = 0.72;

const getAspectRatio = (imageEl: HTMLImageElement | undefined) => {
  let aspectRatio = DEFAULT_ASPECT_RATIO;
  if (imageEl) {
    aspectRatio = imageEl.naturalWidth / imageEl.naturalHeight;
  }
  return aspectRatio;
};

export const GalleryECard: React.FC<Props> = ({ index, data, isHovered, isSlider, ...props }) => {
  const [aspectRatio, setAspectRatio] = useState(DEFAULT_ASPECT_RATIO);
  const [isLoaded, setLoaded] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const onImageLoaded = (imageEl: HTMLImageElement) => {
    setAspectRatio(getAspectRatio(imageEl));
    setLoaded(true);
  };
  useEffect(() => {
    const imageEl = wrapperRef.current?.querySelector('img');
    if (imageEl?.complete) {
      onImageLoaded(imageEl);
    }
  }, []);

  const { t } = useTranslation('galleryPage');
  const GalleryPageContentData = t('galleryPage');
  const { designs } = t('productTypes');

  const coverSrc = data.imageUrl;
  // pages render only card that have themeId defined
  const cardTypeLabel = GalleryPageContentData[data.productType]?.heading;
  return (
    <ECardWrapper {...props} ref={wrapperRef}>
      <ECardImageWrapper aspectRatio={aspectRatio}>
        {isSlider ? (
          <EarlyLoadECardImage
            src={coverSrc + '&width=' + (window.innerWidth < 640 ? '250' : '650')}
            alt={`${data.title ? data.title : 'A Native Circle'} ${cardTypeLabel}`}
            $isHovered={isHovered}
            onLoad={({ currentTarget }) => {
              onImageLoaded(currentTarget);
            }}
            height="100%"
            loading={index < 3 ? 'eager' : 'lazy'}
            itemProp="image"
          />
        ) : (
          <ECardImage
            src={coverSrc + '&width=450'}
            alt={`${data.title ? data.title : 'A Native Circle'} ${cardTypeLabel}`}
            $isLoaded={isLoaded}
            $isHovered={isHovered}
            onLoad={({ currentTarget }) => {
              onImageLoaded(currentTarget);
            }}
            height="100%"
            isDesign={data.productType === designs}
            width={data.productType === designs ? '350px' : '231px'}
            optimization="aggressive"
            itemProp="image"
          />
        )}
      </ECardImageWrapper>
    </ECardWrapper>
  );
};
